import Navbar from '@/common/components/Navbar'
import { Box } from '@mui/material'
import { ReactNode } from 'react'
import { Layout } from './styles/Layout.styles'
import { PageContainerLayout } from './styles/PageContainer.styles'

interface Props {
  children: ReactNode
  gradient?: ReactNode
  showSignButton?: boolean
}

export default function PageLayout({ children, gradient, showSignButton }: Props) {
  return (
    <Layout>
      {gradient}
      <PageContainerLayout>
        <Navbar showSignButton={showSignButton}/>
        <Box m={'80px 0'} width={1}>
          {children}
        </Box>
      </PageContainerLayout>
    </Layout>
  )
}
